/* eslint-disable compat/compat */
import React from 'react'
import { string, arrayOf, number, shape, bool, node } from 'prop-types'
import classNames from 'classnames'
import {
	AccordionProvider,
	AccordionItem,
	AccordionButton,
} from '@/components/Accordion'
import Image from '@/utils/Image'
import IconWrapper from '@/utils/IconWrapper'
import EmailFillIcon from '@/icons/email_fill.svg'
import Raw from '@/utils/Raw'
import WeChatPopUp from '@/components/WeChatPopUp'
// import Email from '@/icons/email.svg'
import * as T from '@/types'

function HeadShot({ image }) {
	const { optimisedPhoto, ...imageProps } = image
	return <Image {...imageProps} image={optimisedPhoto} />
}

HeadShot.propTypes = {
	image: shape(T.craftImage),
}

function AccordionButtonWrap({ expandable, children, index }) {
	return expandable ? (
		<AccordionButton
			className="w-full text-left focus:outline-none"
			index={index}
		>
			{children}
		</AccordionButton>
	) : (
		<div className="w-full text-left focus:outline-none">{children}</div>
	)
}

AccordionButtonWrap.propTypes = {
	expandable: bool.isRequired,
	children: node.isRequired,
	index: number.isRequired,
}

function AccordionContentWrap({ expandable, children, index }) {
	return expandable ? (
		<AccordionItem index={index}>{children}</AccordionItem>
	) : (
		<div>{children}</div>
	)
}

AccordionContentWrap.propTypes = {
	expandable: bool.isRequired,
	children: node.isRequired,
	index: number.isRequired,
}

function Member({
	index,
	jobTitle,
	title,
	body,
	photo,
	email,
	wechat,
	// telephone,
}) {
	const [image] = photo
	const expandable = !!body || !!image

	return (
		<li className="border-b border-soft md:w-1/2 md:odd:border-r">
			<div
				className={classNames({
					'lg:ml-auto lg:max-w-half/wrapper': index % 2 === 0,
					'lg:mr-auto lg:max-w-half/wrapper': index % 2 !== 0,
				})}
			>
				<div className="flex items-start justify-between px-8 py-6">
					<AccordionButtonWrap expandable={expandable} index={index}>
						<div className="mb-1 text-2xl leading-none text-orange">
							{title}
						</div>
						<div className="text-lg leading-none">{jobTitle}</div>
						{/* {telephone && <a href={`tel:${telephone}`}>{telephone}</a>} */}
					</AccordionButtonWrap>

					<IconWrapper
						icon={EmailFillIcon}
						as="a"
						href={`mailto:${email}`}
						className="flex-shrink-0 w-5 text-orange"
					/>
					{wechat?.length > 0 && (
						<WeChatPopUp className="ml-4 text-orange" image={wechat} />
					)}
				</div>

				<AccordionContentWrap expandable={expandable} index={index}>
					<div className="px-8 pb-6 text-dark">
						{body && <Raw className="mb-8" content={body} />}
						{image && <HeadShot image={image} />}
					</div>
				</AccordionContentWrap>
			</div>
		</li>
	)
}

Member.propTypes = {
	index: number.isRequired,
	jobTitle: string.isRequired,
	title: string.isRequired,
	body: string.isRequired,
	photo: arrayOf(T.craftImagePhoto),
	email: string.isRequired,
}

function Team({ title, team }) {
	return (
		<AccordionProvider>
			<header className="py-6 border-b border-soft">
				<div className="px-8 wrapper">
					<h2 className="text-lg font-semibold text-dark">{title}</h2>
				</div>
			</header>
			<ul className="w-full md:flex md:flex-wrap">
				{team.map((entry, index) => (
					<Member key={entry.id} index={index} {...entry} />
				))}
			</ul>
		</AccordionProvider>
	)
}

Team.propTypes = {
	title: string.isRequired,
	team: arrayOf(T.personProps),
}

export default Team
